import { z } from 'zod';

export const schema = z.object({
    taxRate: z.string().nullable(),
    discount: z.number().nullable(),
    discountType: z.enum(['Amount', 'Percent']), // TODO: Fix it types mismatch error if using values from Enum domain.QBooksDiscountType
});
